import classnames from 'classnames';
import * as React from 'react';
import Header from './header';
import { createStore } from 'redux';
import reducer from '../reducers';
import { Container, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ConfirmModal from '../components/dab/ConfirmModal';
import { getCurrentUser, getLoggedUserId } from '../services/selectors/Accounts';
import { clearRefreshToken, handleLogout } from "./common/functions";


interface IAppFrameProps {
	children: React.ReactNode;
	isLogged: boolean;
	isNeedSpaceAtBottomOfThePage?: boolean;
}

interface IAppFrameState {
	sessionTimeout: number;
	isValid: boolean;
	isAdmin: boolean;
	userName: string;
	isDropdownOpen: boolean;
	showLogoutModal: boolean;
	userRoles: string;
	height: number;
}
const store = createStore(reducer);
class AppFrame extends React.Component<IAppFrameProps, IAppFrameState> {
	constructor(props) {
		super(props);
		this.state = {
			sessionTimeout: 10,
			isValid: false,
			isAdmin: false,
			userName: "",
			isDropdownOpen: false,
			showLogoutModal: false,
			userRoles:"",
			height:0
		};
	}

	componentWillMount() {			
		this.updateDimensions();
	}
	handleNavigate(url: string) {
		window.location.href = url;
	}
    handleClickLogout() {
		window.sessionStorage.removeItem('memoryRoute');
		window.localStorage.removeItem('refreshToken');
		window.sessionStorage.removeItem('frontLogged');
		clearRefreshToken();
		handleLogout(false);
	}
	handleNavigateAccount() {
	 sessionStorage.setItem('fromPath', '/account');
	 window.location.href = "/user?id=" + getLoggedUserId()
	}

	
	handleLogoutModal(value: boolean) {
		this.setState({ showLogoutModal: false });

		if (value) {
			handleLogout(false);
		}
	}

	updateDimensions = () => {
		this.setState({ height: window.innerHeight });
	};
	componentDidMount() {
		window.addEventListener('resize', this.updateDimensions);
		const user = getCurrentUser();
		if (user != null) {
			this.setState({ userRoles: user.info.roleCodes })
		}
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.updateDimensions);
	}

	public render() {
		const { isNeedSpaceAtBottomOfThePage, children, isLogged } = this.props;
		const classNames = classnames('AppFrame', { ['NoBottom']: isNeedSpaceAtBottomOfThePage, });
		const frontLogged = sessionStorage.getItem('frontLogged');
		return (
			<React.Fragment>
				<div className={classNames} style={{ minHeight: this.state.height-40}}>
					<div id="layout-div" className='layout-container'>
						<div className='layout-child-div'>
							{(!isLogged && window.location.pathname != '/front' && window.location.pathname != '/unauth') && (
								<div className='toolbar'>
									<Dropdown className='dropdown' onClick={this.handleNavigate.bind(this, '/login')} >
										<DropdownToggle>
											<span> Login </span>
										</DropdownToggle>
									</Dropdown>
								</div>)}
							<div style={{ display: `${((isLogged && window.location.pathname != '/forgotpassword') || frontLogged) ? "" : 'none'}` }}>
								<div className='toolbar'>
									{window.location.pathname != '/forgotpassword' && window.location.pathname != '/front' && window.location.pathname != '/unauth' && !frontLogged &&
										<>{(this.state.userRoles.includes('Admin') || this.state.userRoles.includes('Channel')) &&
											<Dropdown className='dropdown' direction="down" isOpen={this.state.isDropdownOpen}
												onMouseOver={() => this.setState({ isDropdownOpen: true })}
												onFocus={() => this.setState({ isDropdownOpen: true })}
												onMouseLeave={() => this.setState({ isDropdownOpen: false })}
												onBlur={() => this.setState({ isDropdownOpen: false })}
												toggle={() => this.setState({ isDropdownOpen: !this.state.isDropdownOpen })}>
												<DropdownToggle>
													<span data-testid="admin-Header"> Administration </span>
												</DropdownToggle>
												<DropdownMenu className='dropdown-menu'>
													<DropdownItem onClick={this.handleNavigate.bind(this, '/language')} data-testid="language-Header">Languages</DropdownItem>
													{this.state.userRoles.includes('Admin') &&
														<DropdownItem onClick={this.handleNavigate.bind(this, '/user')} data-testid="Adminportal-Header">Admin Portal/Users</DropdownItem>}
												</DropdownMenu>
											</Dropdown>}
										<div className='dropdown' onClick={this.handleNavigateAccount}>
											<button className="btn btn-secondary">
												<span data-testid="account-Header"> Account </span>
											</button>
										</div></>}

									<div className='dropdown' onClick={this.handleClickLogout} data-testid="logoutMenu">
										<button data-testid="logoutMenuToggle" className="btn btn-secondary">
											<span data-testid="logout-Header"> Logout </span>
										</button>
									</div>
								</div>

							</div>
						</div>
					</div>
					<div>
						<ConfirmModal data-testid="modalLogout" isShowModal={this.state.showLogoutModal}
							deleteMessage={"Are you sure, Do you want to logout? "}
							modalChange={this.handleLogoutModal} modalTitle="Logout" />
						<Header sessionTimeout={this.state.sessionTimeout} login={store} isLogged={isLogged} isAdmin={this.state.isAdmin} userName={this.state.userName} />
					</div>
					<main className='Main' >
						{isLogged && (
							<Container>
								<div className='Content'>{children}</div>
							</Container>
						)}
						{!isLogged && (window.location.pathname === "/"
							|| window.location.pathname === "/login"
							|| window.location.pathname === "/forgotpassword"
							|| window.location.pathname === "/front") && (
								<Container>
									<div className='Content'>{children}</div>
								</Container>
							)}
					</main>
				</div>				
			</React.Fragment>
		);
	}
}

export default AppFrame;